export const hasValue = (value) =>
    value !== undefined && value !== null && value !== "undefined" && value !== "null" && value !== "";
